var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "b-settings",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 1.65,
    d: "M22.7 9.8q1.2 1.55 1.5 3.65h2.9v3.25h-2.9q-.3 2.1-1.5 3.65l2.05 2.1-2.3 2.3-2.1-2q-1.55 1.15-3.65 1.5v2.85h-3.3v-2.85q-2.05-.35-3.6-1.5l-2.1 2-2.3-2.3 2-2.1Q6.25 18.8 5.9 16.7H3v-3.25h2.9q.35-2.1 1.5-3.65l-2-2.1 2.3-2.3 2.1 2q1.55-1.15 3.6-1.5V3.05h3.3V5.9q2.1.35 3.65 1.5l2.1-2 2.3 2.3-2.05 2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c-settings",
    fill: "none",
    stroke: "#E0E0E0",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 1.65,
    d: "M15.1 18.1q1.2 0 2.15-.9.85-.9.85-2.15 0-1.2-.85-2.1-.95-.9-2.15-.9-1.3 0-2.15.9-.9.9-.9 2.1 0 1.25.9 2.15.85.9 2.15.9Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "a-settings"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m22.45 5.4-2.1 2Q18.8 6.25 16.7 5.9V3.05h-3.3V5.9q-2.05.35-3.6 1.5l-2.1-2-2.3 2.3 2 2.1q-1.15 1.55-1.5 3.65H3v3.25h2.9q.35 2.1 1.5 3.65l-2 2.1 2.3 2.3 2.1-2q1.55 1.15 3.6 1.5v2.85h3.3v-2.85q2.1-.35 3.65-1.5l2.1 2 2.3-2.3-2.05-2.1q1.2-1.55 1.5-3.65h2.9v-3.25h-2.9q-.3-2.1-1.5-3.65l2.05-2.1-2.3-2.3m-5.2 11.8q-.95.9-2.15.9-1.3 0-2.15-.9-.9-.9-.9-2.15 0-1.2.9-2.1.85-.9 2.15-.9 1.2 0 2.15.9.85.9.85 2.1 0 1.25-.85 2.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E0E0E0",
    d: "M15.1 18.1q1.2 0 2.15-.9.85-.9.85-2.15 0-1.2-.85-2.1-.95-.9-2.15-.9-1.3 0-2.15.9-.9.9-.9 2.1 0 1.25.9 2.15.85.9 2.15.9Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a-settings"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b-settings"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c-settings"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSettings);
export default __webpack_public_path__ + "static/media/icon-settings.c3baa8a41b3b5e19db07ba74a399f24c.svg";
export { ForwardRef as ReactComponent };